export const setValueWithAccessor = (data, accessor) => {
    // if no '.', then it's not a deep value
    if (accessor.indexOf('.') < 0) {
        // data[field] = newValue;
        return data[accessor];
    }
    else {
        // otherwise it is a deep value, so need to dig for it
        const accessorPieces = accessor.split('.');
        let currentObject = data;
        while (accessorPieces.length > 0 && currentObject) {
            const fieldPiece = accessorPieces.shift();
            if (accessorPieces.length === 0) {
                return currentObject[fieldPiece];
            }
            else {
                currentObject = currentObject[fieldPiece];
            }
        }
    }
};
